import { put, call } from "redux-saga/effects";
import { push } from 'react-router-redux';
import Swal from "sweetalert2";
import {
    getJobSuccess, getJobFail,
    getAllJobsSuccess, getAllJobsFail,
    getActiveJobsSuccess, getActiveJobsFail,
    getJobsByCategorySuccess, getJobsByCategoryFail,
    createJobSuccess, createJobFail,
    updateJobSuccess, updateJobFail,
    deleteJobSuccess, deleteJobFail,
    setJobLoading, IMPORT_JOBS_EXCEL_SUCCESS, getAllJobsRequest, IMPORT_JOBS_EXCEL_FAIL, EXPORT_JOBS_SUCCESS,
    EXPORT_JOBS_FAIL, DOWNLOAD_JOBS_TEMPLATE_SUCCESS, DOWNLOAD_JOBS_TEMPLATE_FAIL
} from "../actions/Jobactions";
import {
    API_BASE_URL,
    getRequest,
    postRequest,
    putRequest,
    deleteRequest, getBlobRequest
} from "../../../api";
import {downloadBlob} from "./formationsSaga";


export function* getJobSaga(action) {
    const url = `${API_BASE_URL}/api/jobs/${action.payload.jobId}`;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 GET_JOB_REQUEST');
        console.log('📊 Job ID:', action.payload.jobId);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_JOB_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getJobSuccess(resp.data));
        yield put(setJobLoading(false));

    } catch (error) {
        console.group('❌ GET_JOB_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getJobFail(error.message));
        yield put(setJobLoading(false));
        // toast.error("Erreur lors de la récupération du poste");
    }
}

export function* getAllJobsSaga(action) {
    const token = sessionStorage.getItem('token');

    const url = `${API_BASE_URL}/api/jobs`;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 GET_ALL_JOBS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url,token });

        console.group('✅ GET_ALL_JOBS_SUCCESS');
        console.log('📥 Nombre de postes:', resp.data.length);
        console.groupEnd();

        yield put(getAllJobsSuccess(resp.data));
        yield put(setJobLoading(false));

    } catch (error) {
        console.group('❌ GET_ALL_JOBS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllJobsFail(error.message));
        yield put(setJobLoading(false));
        // toast.error("Erreur lors de la récupération des postes");
    }
}

export function* getActiveJobsSaga(action) {
    const url = `${API_BASE_URL}/api/jobs/active`;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 GET_ACTIVE_JOBS_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_ACTIVE_JOBS_SUCCESS');
        console.log('📥 Nombre de postes actifs:', resp.data.length);
        console.groupEnd();

        yield put(getActiveJobsSuccess(resp.data));
        yield put(setJobLoading(false));

    } catch (error) {
        console.group('❌ GET_ACTIVE_JOBS_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getActiveJobsFail(error.message));
        yield put(setJobLoading(false));
        // toast.error("Erreur lors de la récupération des postes actifs");
    }
}

export function* getJobsByCategorySaga(action) {
    const url = `${API_BASE_URL}/api/jobs/category/${action.payload.category}`;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 GET_JOBS_BY_CATEGORY_REQUEST');
        console.log('📊 Catégorie:', action.payload.category);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_JOBS_BY_CATEGORY_SUCCESS');
        console.log('📥 Nombre de postes:', resp.data.length);
        console.groupEnd();

        yield put(getJobsByCategorySuccess(resp.data));
        yield put(setJobLoading(false));

    } catch (error) {
        console.group('❌ GET_JOBS_BY_CATEGORY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getJobsByCategoryFail(error.message));
        yield put(setJobLoading(false));
        // toast.error("Erreur lors de la récupération");
    }
}

export function* createJobSaga(action) {
    const url = `${API_BASE_URL}/api/jobs`;
    const data = action.payload;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 CREATE_JOB_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data });

        console.group('✅ CREATE_JOB_SUCCESS');
        console.log('📥 Poste créé:', resp.data);
        console.groupEnd();

        yield put(createJobSuccess(resp.data));
        yield put(setJobLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Poste créé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        // Redirection optionnelle
        if (action.history) {
            yield put(push('/jobs'));
        }

    } catch (error) {
        console.group('❌ CREATE_JOB_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(createJobFail(error.message));
        yield put(setJobLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la création",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* updateJobSaga(action) {
    const url = `${API_BASE_URL}/api/jobs/${action.payload.jobId}`;
    const data = action.payload.jobData;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 UPDATE_JOB_REQUEST');
        console.log('📊 Job ID:', action.payload.jobId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data });

        console.group('✅ UPDATE_JOB_SUCCESS');
        console.log('📥 Poste mis à jour:', resp.data);
        console.groupEnd();

        yield put(updateJobSuccess(resp.data));
        yield put(setJobLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Poste mis à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ UPDATE_JOB_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateJobFail(error.message));
        yield put(setJobLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la mise à jour",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* deleteJobSaga(action) {
    const url = `${API_BASE_URL}/api/jobs/${action.payload.jobId}`;
    yield put(setJobLoading(true));

    try {
        console.group('🔵 DELETE_JOB_REQUEST');
        console.log('📊 Job ID:', action.payload.jobId);
        console.groupEnd();

        yield call(deleteRequest, { url });

        console.group('✅ DELETE_JOB_SUCCESS');
        console.log('🗑️ Poste supprimé');
        console.groupEnd();

        yield put(deleteJobSuccess(action.payload.jobId));
        yield put(setJobLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: "Poste supprimé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        if (action.history) {
            yield put(push('/jobs'));
        }

    } catch (error) {
        console.group('❌ DELETE_JOB_FAIL');
        console.error('🚨 Erreur complète:', error);
        console.error('🚨 Response data:', error.response?.data);
        console.error('🚨 Response status:', error.response?.status);
        console.groupEnd();

        yield put(setJobLoading(false));

        // Extraire le message d'erreur
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteJobFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur de suppression',
            text: errorMessage,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    }
}

// ── Import Excel ──────────────────────────────────────────
export function* importJobsExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    const { file, dryRun, action: act } = action.payload;

    try {
        const fd = new FormData();
        fd.append("file", file);

        const url = `${API_BASE_URL}/api/jobs/import-excel?dryRun=${dryRun ? "true" : "false"}&action=${act}`;

        const res = yield call(postRequest, {
            url,
            data: fd,
            token,
            extraHeaders: { uid },
        });

        yield put({ type: IMPORT_JOBS_EXCEL_SUCCESS, payload: res.data });

        if (!dryRun) {
            Swal.fire({
                icon: "success",
                title: "Import terminé",
                text: `${res.data.createdCount} ligne(s) traitée(s), ${res.data.skippedCount} ignorée(s)`,
            });
            yield put(getAllJobsRequest());
        } else {
            Swal.fire({
                icon: "info",
                title: "Prévisualisation",
                text: `${res.data.createdCount} ligne(s) valide(s), ${res.data.skippedCount} erreur(s)`,
            });
        }
    } catch (e) {
        yield put({ type: IMPORT_JOBS_EXCEL_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur import", text: "Import Excel échoué" });
    }
}

// ── Export Excel ──────────────────────────────────────────
export function* exportJobsExcelSaga() {
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");

    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/jobs/export-excel`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });

        downloadBlob(new Blob([res.data]), "export_jobs.xlsx");
        yield put({ type: EXPORT_JOBS_SUCCESS });
    } catch (e) {
        yield put({ type: EXPORT_JOBS_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur", text: "Export échoué" });
    }
}

// ── Download Template ─────────────────────────────────────
export function* downloadJobsTemplateSaga() {
    const token = sessionStorage.getItem("token");

    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/jobs/template`,
            token: `Bearer ${token}`,
        });

        downloadBlob(new Blob([res.data]), "template_postes.xlsx");
        yield put({ type: DOWNLOAD_JOBS_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({ type: DOWNLOAD_JOBS_TEMPLATE_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template échoué" });
    }
}
